import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const servicesAndGoods = dictionary.extend({
  name: z.string().min(1),
  invoice_description: z.string().max(250).optional(),
  code: z.string().min(1),
});
export const readServicesAndGoods = servicesAndGoods.readonly();
export const writeServicesAndGoods = servicesAndGoods.omit({ id: true });
